import React, { useState } from 'react';
import { cleanName, NAME_RULE, secretProblem } from '../utility/fieldRules';
import '../styles/SizeOption.scss';

/** A form rule, shown only while something breaks it. */
export const FieldRule: React.FC<{ text: string | null }> = ({ text }) => (text ? <p className="field-rule" role="alert">{text}</p> : null);

// the same mark, in the same colour, as the other fields' labels
const Required = () => <span style={{ color: 'var(--color-error,#e53e3e)' }} aria-hidden="true">*</span>;

/** The resource's name: cleaned as typed, and the rule shown only when a character was just dropped. */
export const NameField: React.FC<{ value: string; onChange: (v: string) => void; placeholder: string; label?: string }> = ({ value, onChange, placeholder, label = 'Name' }) => {
    const [rejected, setRejected] = useState(false);
    return (
        <div className="form-group">
            <label>{label} <Required /></label>
            <input
                value={value}
                aria-label={label}
                onChange={(e) => { const r = cleanName(e.target.value); setRejected(r.rejected); onChange(r.value); }}
                placeholder={placeholder}
            />
            <FieldRule text={rejected ? NAME_RULE : null} />
        </div>
    );
};

/** A password or key the platform generates when left empty; its rule shows only once something breaks it. */
export const SecretField: React.FC<{ label: string; value: string; onChange: (v: string) => void; charset?: boolean }> = ({ label, value, onChange, charset }) => {
    const [left, setLeft] = useState(false);
    return (
        <div className="form-group">
            <label>{label}</label>
            <input
                type="password"
                aria-label={label}
                value={value}
                onChange={(e) => onChange(e.target.value)}
                onBlur={() => setLeft(true)}
                placeholder="Generated if empty"
            />
            <FieldRule text={secretProblem(value, { charset, left })} />
        </div>
    );
};

/** A size and its monthly price on one line, the price at the right: in the menu and in the picked value. */
export const formatSizeOption = (o: { label: string; price?: string | null }) => (
    <span className="db-size-option">
        <span className="db-size-name">{o.label}</span>
        {o.price && <span className="db-size-price">{o.price}</span>}
    </span>
);
